import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-source-code-view',
  template: '<div class="text-primary fst-italic text-break text-wrap" *ngIf="code != sourceCode">{{sourceCode}}</div>',
  styles: []
})
export class SourceCodeViewComponent {
  @Input() code: string;
  @Input() sourceCode: string;
}
